// extracted by mini-css-extract-plugin
export default {"container":"ContentEditable_container__-kpOj","containerFocused":"ContentEditable_containerFocused__7pS-G"};